import { Box, ButtonBase, Popper, Typography } from "@mui/material";
import { styled } from "@mui/material/styles";

export const Trigger = styled(ButtonBase)(({ theme }) => ({
  width: "100%",
  justifyContent: "flex-start",
  gap: theme.spacing(1),
  padding: theme.spacing(1.25, 1.5),
  border: `1px solid ${theme.palette.divider}`,
  borderRadius: theme.shape.borderRadius,
  backgroundColor: theme.palette.background.paper,
  textAlign: "left",
}));

export const Dot = styled(Box, {
  shouldForwardProp: (prop) => prop !== "$color",
})<{ $color?: string }>(({ $color, theme }) => ({
  width: 10,
  height: 10,
  borderRadius: "50%",
  flexShrink: 0,
  backgroundColor:
    $color ??
    (theme.palette.mode === "dark"
      ? theme.palette.gold.dark
      : theme.palette.yellow.dark),
}));

export const Label = styled(Typography)({
  flex: 1,
  minWidth: 0,
  fontSize: 14,
  overflow: "hidden",
  textOverflow: "ellipsis",
  whiteSpace: "nowrap",
});

export const Menu = styled(Popper)(({ theme }) => ({
  zIndex: theme.zIndex.modal + 1,
}));
